import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue') },
  { path: '/', name: 'launcher', component: () => import('@/views/LauncherView.vue'), meta: { requiresAuth: true } },
  { path: '/carburant', name: 'carburant', component: () => import('@/views/apps/CarburantView.vue'), meta: { requiresAuth: true } },
  { path: '/finance', name: 'finance', component: () => import('@/views/apps/FinanceView.vue'), meta: { requiresAuth: true } },
  { path: '/notes', name: 'notes', component: () => import('@/views/apps/NotesView.vue'), meta: { requiresAuth: true } },
  { path: '/reseau', name: 'reseau', component: () => import('@/views/apps/ReseauView.vue'), meta: { requiresAuth: true } },
  { path: '/parametres', name: 'parametres', component: () => import('@/views/apps/ParametresView.vue'), meta: { requiresAuth: true } },
  { path: '/personnaliser', name: 'personnaliser', component: () => import('@/views/apps/PersonnaliserView.vue'), meta: { requiresAuth: true } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// La restauration de session (jeton en localStorage → GET /api/auth/verifier) est
// asynchrone mais ne doit être tentée qu'une fois — mémorisée ici plutôt que refaite
// à chaque navigation.
let restaurationSession = null

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (!restaurationSession) {
    restaurationSession = auth.sessionToken ? Promise.resolve(true) : auth.verifierSessionExistante()
  }
  await restaurationSession

  if (to.meta.requiresAuth && !auth.authentifie) {
    return { name: 'login' }
  }
  if (to.name === 'login' && auth.authentifie) {
    return { name: 'launcher' }
  }
  return true
})

export default router
